import { useEffect } from 'react';
import { useSetImmerAtom } from 'jotai-immer';
import { ngContext } from '../../../../core/services/ng.delegate';
import utilSvc from '../../../../core/utilSvc';
import { pageStateVM } from '../../../../core/page/page_view_models';

import { CLAIM_IRA_EDIT } from '../../ira_const';
import { iraImportStateAtom, pageStateAtom } from '../ira_list_atoms';
import { iraImportStateVM } from '../ira_view_models';

export const useIraListInit = (): void => {
    const setState = useSetImmerAtom(pageStateAtom);
    const setImport = useSetImmerAtom(iraImportStateAtom);

    // INIT
    useEffect(() => {
        setState(draft => {
            // get context from Angular and set permissions every time
            const ctx = ngContext();
            draft.canEdit = !!ctx && !!ctx.User ? utilSvc.user.hasFeature(ctx.User, CLAIM_IRA_EDIT) : false;
            return draft;
        });

        // destroy
        return (): void => {
            setState(() => pageStateVM());
            setImport(() => iraImportStateVM());
        };
    }, [setState, setImport]);
};
